import React from 'react';
import styles from './Grain.module.css';

const Grain: React.FC = () => (
  <svg className={styles.grain} aria-hidden="true">
    <filter id="grain-filter">
      <feTurbulence
        type="fractalNoise"
        baseFrequency="0.8"
        numOctaves="3"
        stitchTiles="stitch"
      />
      <feColorMatrix type="saturate" values="0" />
    </filter>
    <rect width="100%" height="100%" filter="url(#grain-filter)" />
  </svg>
);

export default Grain;
